import { Box, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material';
import DialogBaseCC from 'components/Dialog/DialogBaseCC';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DIALOG_ID } from './constant';

const DialogExpireService = () => {
    const { t } = useTranslation();
    const { days = 1 } = useSelector((state) => state.dialog);

    return (
        <DialogBaseCC id={DIALOG_ID.EXPIRE_SERVICE} title={t('dialog.expire-service.title')}>
            <DialogContent sx={{ maxWidth: '100% !important' }}>
                <DialogContentText sx={{ maxWidth: '100% !important', display: 'flex', flexDirection: 'column' }}>
                    <Box>
                        {t('dialog.expire-service.content-1')}{' '}
                        <Typography sx={{ color: theme => theme.palette.secondary.main, fontWeight: '600' }}>
                            {days} {t('dialog.expire-service.day')}.
                        </Typography>
                        {t('dialog.expire-service.content-2')} {t('dialog.expire-service.content-3')}{' '}
                        <Typography
                            sx={{
                                fontWeight: '600',
                                textDecorationLine: 'underline',
                                fontStyle: 'italic',
                                color: theme => theme.palette.secondary.main,
                            }}
                        >
                            {t('dialog.expire-service.content-4')}
                        </Typography>
                        {t('dialog.expire-service.content-5')}!
                    </Box>
                    <Box>{t('dialog.expire-service.content-6')}</Box>
                    <Box>{t('dialog.expire-service.content-7')}</Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions></DialogActions>
        </DialogBaseCC>
    );
};

export default DialogExpireService;
